import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getMilestoneStatusApi = async () => {
  try {
    const response = await axios.get(apiUrl + `getMilestoneStatus`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitMilestoneAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `milestone`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateMilestoneAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `milestone/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getMilestoneEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `milestone/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getMilestonesListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `milestone`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteMilestoneApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `milestone/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
